import { c as _c } from "react/compiler-runtime";
import NextLink from 'next/link';
import type React from 'react';
import { HiLink, HiPencilSquare } from 'react-icons/hi2';
import { twMerge } from 'tailwind-merge';
import { CruzIcon } from '@/components';
const variantStyles = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  outline: 'btn-outline',
  outlineHc: 'btn-outline-hc'
};
type Props = {
  variant?: keyof typeof variantStyles;
  href: string;
  label: string | React.ReactNode;
  count?: number;
  icon?: 'new' | 'edit' | 'view' | 'link' | 'search' | 'home';
} & React.ComponentPropsWithoutRef<'a'>;
const iconStyle = 'size-4 -ml-1';
export function LinkButton(t0) {
  const $ = _c(26);
  let className;
  let count;
  let href;
  let icon;
  let label;
  let rest;
  let variant;
  if ($[0] !== t0) {
    ({
      variant,
      href,
      label,
      count,
      icon,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = count;
    $[3] = href;
    $[4] = icon;
    $[5] = label;
    $[6] = rest;
    $[7] = variant;
  } else {
    className = $[1];
    count = $[2];
    href = $[3];
    icon = $[4];
    label = $[5];
    rest = $[6];
    variant = $[7];
  }
  let t1;
  if ($[8] !== icon) {
    t1 = () => {
      switch (icon) {
        case "new":
          {
            return <CruzIcon.Plus className={iconStyle} />;
          }
        case "edit":
          {
            return <HiPencilSquare className={iconStyle} />;
          }
        case "view":
        case "search":
          {
            return <CruzIcon.Search className={iconStyle} />;
          }
        case "link":
          {
            return <HiLink className={iconStyle} aria-hidden="true" />;
          }
        case "home":
          {
            return <CruzIcon.Home className={iconStyle} aria-hidden="true" />;
          }
        default:
          {
            return null;
          }
      }
    };
    $[8] = icon;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const renderIcon = t1;
  const t2 = variantStyles[variant || "primary"];
  let t3;
  if ($[10] !== className || $[11] !== t2) {
    t3 = twMerge("transition duration-300", "flex h-10 items-center justify-center gap-x-2 rounded px-4 text-sm truncate sm:px-5", t2, className);
    $[10] = className;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== renderIcon) {
    t4 = renderIcon();
    $[13] = renderIcon;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== label) {
    t5 = <span className="truncate">{label}</span>;
    $[15] = label;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== count) {
    t6 = !!count && <span className="nav-count ml-2 min-w-[18px] text-center text-xs font-normal"><span className="sr-only">{count} items</span><span aria-hidden="true">{count}</span></span>;
    $[17] = count;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== href || $[20] !== rest || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = <NextLink href={href} className={t3} hrefLang="en" {...rest}>{t4}{t5}{t6}</NextLink>;
    $[19] = href;
    $[20] = rest;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}